/**
 * i18n ขั้นต่ำ — CLAUDE.md ข้อ 1: ห้าม hardcode ข้อความไทยใน component
 *
 * จงใจไม่ใช้ไลบรารีใหญ่ (i18next) ใน Sprint 0 เพราะยังมีสองภาษาและไม่มี
 * plural/format ที่ซับซ้อน ถ้าถึงจุดที่ต้องใช้ค่อยเปลี่ยน โดยที่ signature ของ
 * `t()` ยังเหมือนเดิม component จึงไม่ต้องแก้
 */
import en from './en.json'
import th from './th.json'

export const LOCALES = ['th', 'en'] as const
export type Locale = (typeof LOCALES)[number]

export const DEFAULT_LOCALE: Locale = 'th'

const dictionaries: Record<Locale, unknown> = { th, en }

function lookup(dict: unknown, path: string): string | undefined {
  const value = path.split('.').reduce<unknown>((acc, key) => {
    if (acc && typeof acc === 'object' && key in acc) {
      return (acc as Record<string, unknown>)[key]
    }
    return undefined
  }, dict)
  return typeof value === 'string' ? value : undefined
}

/**
 * แปลข้อความตาม key แบบ dot notation เช่น `t('nav.learn')`
 *
 * ถ้าไม่เจอใน locale ที่ขอ จะถอยไป th ก่อน แล้วค่อยคืน key เดิม
 * (คืน key ดีกว่าคืนค่าว่าง เพราะเห็นทันทีว่าลืมแปลตรงไหน)
 */
export function translate(
  key: string,
  locale: Locale = DEFAULT_LOCALE,
  vars?: Record<string, string | number>,
): string {
  const raw = lookup(dictionaries[locale], key) ?? lookup(dictionaries[DEFAULT_LOCALE], key) ?? key

  if (!vars) return raw
  // ใช้ split/join แทน replaceAll เพื่อคง target ไว้ที่ ES2020
  // (Safari บน iPad รุ่นเก่ายังเป็นอุปกรณ์เป้าหมายอันดับ 1 — CLAUDE.md §6)
  return Object.entries(vars).reduce(
    (acc, [name, value]) => acc.split(`{{${name}}}`).join(String(value)),
    raw,
  )
}
